import {
	RESET_GENERATING_UNIT_FEATURES, SET_FEATURES_ERROR, SET_GENERATING_UNIT_FEATURES_RESULT
} from "./GeneratingUnitFeaturesActionTypes";
import GeneratingUnitFeaturesFactory from "../factories/GeneratingUnitFeaturesFactory";

const mutations = {
	[SET_GENERATING_UNIT_FEATURES_RESULT]: (state, resp) =>
	{
		resp.forEach(group =>
		{
			group.features.forEach(feature =>
			{
				state[group.name][feature.name] = feature.enabled;
			});
		});
	},
	[SET_FEATURES_ERROR]: (state, error) =>
	{
		state.error = error;
	},
	[RESET_GENERATING_UNIT_FEATURES]: (state) =>
	{
		Object.keys(GeneratingUnitFeaturesFactory.EmptyState()).forEach(group =>
		{
			state[group] = { ...GeneratingUnitFeaturesFactory.EmptyState()[group] };
		});
		state.error = null;
	}
};

export default { mutations };